import { REMOVE_PHOTO } from '../actionTypes'

export const removePhoto = (data: object) => ({
  type: REMOVE_PHOTO.name,
  api: {
    url: 'photos/remove',
    data,
  },
})
